module.exports = __webpack_public_path__ + "static/media/exp design.4ab49a43.svg";